import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-total-users-using-discount',
  templateUrl: './tryout-total-users-using-discount.component.html',
  styleUrls: ['./tryout-total-users-using-discount.component.css']
})
export class TryoutTotalUsersUsingDiscountComponent implements OnInit {

  @Input() NoOfTotalUserUsingDiscount: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-users-using-discount/tryout-total-users-using-discount.component.ts